<div class="auditItem Log-Category">

  <div class="auditIconWrap">
    <!-- <div class="auditBadgeIcon" [ngClass]="getSeverityClass()"></div> -->
    <div class="auditIcon" title="Log"></div>
  </div>
  <div class="auditInfo">
    <div class="auditHeader"><span class="auditTimestamp">{{log?.updated |  formatDateWithTimezone | async}}</span> <span
        (click)="isSelected ? unselected.emit() : selected.emit()" class="showAuditDetails">
        <mat-icon>info</mat-icon>
      </span></div>
    <div class="auditDescription">
      <p>
        <span class="logType" appLogAuditSeverityStyle [level]="log!.severity">{{log?.severity}} </span>
        <span class="logText">{{log?.comment}}</span>
      </p>
    </div>
    <div class="auditCommentWrap">

      <div class="auditCommentText">
        <p>
          Source: {{log?.source}}
        </p>
      </div>
    </div>
  </div>
</div>
